import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { DocumentLinkCreated } from '../../documentLink/DocumentLinkCreated'

@InputType()
export class CreateOrderPackingSlipDocumentLinkArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string
}

export interface ICreateOrderPackingSlipDocumentLink extends IAction<
  DocumentLinkCreated,
  CreateOrderPackingSlipDocumentLinkArgs
> {}
